// import React from "react";
import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getNotificationsByType } from "../../services/Notification";

const NotificationMenu = () => {
  const [notifications, setNotifications] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await getNotificationsByType();
        if (response?.status === 200 || response?.status === 201) {
          const list = response.data.data || [];
          // Filter: only notifications with senderRole (worker or admin)
          const filteredList = list.filter(
            (item) => item.senderRole && (item.senderRole === "worker" || item.senderRole === "admin")
          );
          setNotifications(filteredList);
        }
      } catch (e) {
        console.log("Failed to load notifications in menu", e);
      }
    };

    fetchNotifications();
  }, []);

  return (
    <Box sx={{ borderRadius: 2, p: 2 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography
          variant="subtitle1"
          fontSize={14}
          fontWeight={600}
          color="#222"
        >
          Notifications
        </Typography>
      </Box>
      {notifications.length === 0 ? (
        <Typography fontSize={12} color="#777">
          No notifications yet.
        </Typography>
      ) : (
        notifications.slice(0, 5).map((item) => (
          <Box
            key={item._id}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 0.5,
              py: 1,
              borderBottom: "1px solid #eee",
            }}
          >
            <Typography fontSize={13} fontWeight={600} color="#222">
              {item.title}
            </Typography>
            <Typography fontSize={12} color="#555">
              {item.body}
            </Typography>
          </Box>
        ))
      )}
    </Box>
  );
};

export default NotificationMenu;
